import React, { useState } from "react";
import { adminLogin } from "../../api/adminApi";
import PasswordInput from "../../components/PasswordInput";
import AdminForgotPasswordModal from "./AdminForgotPasswordModal";
import "../../styles/admin.css";

function AdminLogin() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [showForgotModal, setShowForgotModal] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setError("");

    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      setError("ایمیل و رمز عبور الزامی هستند.");
      return;
    }

    try {
      setLoading(true);

      const data = await adminLogin(formData);

      localStorage.setItem("staffToken", data.token);
      localStorage.setItem("staffUser", JSON.stringify(data.staff));

      window.location.href = "/admin/dashboard";
    } catch (err) {
      setError(err.message || "ورود ناموفق بود.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-auth-page">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <span className="admin-badge">پنل داخلی شرکت</span>
          <h1>ورود اعضای شرکت</h1>
          <p>برای مدیریت اخبار و دوره‌های آموزشی وارد شوید.</p>
        </div>

        {error && <div className="admin-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="admin-field">
            <label>ایمیل</label>

            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="admin@iemictlearn.com"
              autoComplete="email"
            />
          </div>

          <div className="admin-field">
            <label>رمز عبور</label>

            <PasswordInput
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="رمز عبور"
              required
              autoComplete="current-password"
            />
          </div>

          <button className="admin-submit-btn" type="submit" disabled={loading}>
            {loading ? "در حال ورود..." : "ورود به پنل"}
          </button>
        </form>

        <button
          type="button"
          className="admin-forgot-link"
          onClick={() => setShowForgotModal(true)}
        >
          رمز عبور خود را فراموش کرده‌اید؟
        </button>

        <button
          className="admin-back-btn"
          type="button"
          onClick={() => {
            window.location.href = "/";
          }}
        >
          بازگشت به سایت
        </button>
      </div>

      {showForgotModal && (
        <AdminForgotPasswordModal
          onClose={() => setShowForgotModal(false)}
        />
      )}
    </div>
  );
}

export default AdminLogin;